import ImageVideo from './ImageVideo';

export default ImageVideo;
